import React, { useState, useCallback, useEffect, useMemo } from "react";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { skillsAPI } from "../../api/skillm";
import * as XLSX from "xlsx";

const SkillMatrix = () => {
   
  const columns = useMemo(
    () => [
      {
        name: "Skills",
        selector: (row) => row.skill_title,
        wrap: true,
      },
      {
        name: "Number Of Candidates",
        selector: (row) => row.candidates,
      },
    ],
    []
  );

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [reqParams, setReqParams] = useState({
    page: currentPage,
    limit: perPage,
  });

  const [fetch, setFetch] = useState(true);

  const fetchUsers = useCallback(
    (params) => {
      let query = new URLSearchParams(params).toString();
      setLoading(true);
      skillsAPI(query)
        .then((res) => {
          setData(res?.data);
          setTotalRows(res?.total);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch]
  );

  useEffect(() => {
    if (fetch) {
      fetchUsers(reqParams);
    }
  }, [fetch, reqParams, fetchUsers]);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  // Function to handle download as Excel
  const downloadExcel = () => {
    // Convert data to a worksheet
    const worksheetData = data.map((d) => ({
      "Skill Title": d.skill_title,
      "Number of Candidates": d.candidates,
    }));
    const worksheet = XLSX.utils.json_to_sheet(worksheetData);

    // Create a workbook and add the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Skill Matrix");

    // Export to Excel
    XLSX.writeFile(workbook, "SkillMatrix.xlsx");
  };

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <button className="btn btn-primary" onClick={downloadExcel}>
          Download Excel
        </button>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <DataTable
              className="table display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              persistTableHead
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SkillMatrix;
